import { useRef } from 'react';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import ModernHero from '../components/sections/ModernHero';
import NationalMissionSection from '../components/sections/NationalMissionSection';
import ModernProgramsSection from '../components/sections/ModernProgramsSection';
import OpenHopeExperienceSection from '../components/sections/OpenHopeExperienceSection';
import ImpactGoalsSection from '../components/sections/ImpactGoalsSection';

export default function Home() {
  const programsRef = useRef<HTMLDivElement>(null);
  const impactRef = useRef<HTMLDivElement>(null);

  return (
    <div className="bg-white dark:bg-gray-900">
      <SEO 
        title="Open Hope Initiative — Building Nigeria's Safety Infrastructure"
        description="Connecting communities to life-saving emergency response through technology that works on any device. Building a safer, more resilient Nigeria."
        canonical="https://openhopeinitiative.com"
      />
      <StructuredData type="organization" />
      
      {/* Hero Section */}
      <section id="home" className="relative">
        <ModernHero />
      </section>
      
      {/* Mission Section */}
      <section id="impact" ref={impactRef}>
        <NationalMissionSection />
      </section>
      
      {/* Programs Section */}
      <section id="programs" ref={programsRef} className="py-12 sm:py-16 md:py-20 bg-white dark:bg-gray-900">
        <ModernProgramsSection />
      </section>

      {/* Our Impact Goals Section */}
      <ImpactGoalsSection />

      {/* The Open Hope Experience */}
      <OpenHopeExperienceSection />

      {/* Our Vision Section - Minimalist */}
      <section className="py-32 sm:py-48 bg-white border-t border-gray-100 flex items-center justify-center text-center px-6">
        <h2 className="font-sans text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-[#0F172A] max-w-5xl leading-tight">
          A Nigeria where every person can access help within minutes.
        </h2>
      </section>
      
      {/* Footer CTA Section - Cinematic */}
      <section className="relative py-32 bg-[#0F172A] overflow-hidden text-center">
        {/* Subtle Dark Image Background */}
        <div className="absolute inset-0 opacity-20">
          <img 
            src="https://res.cloudinary.com/ddf1wv47y/image/upload/v1784303025/7BB823E3-AC6F-47E6-ADE6-7FCDE8719D45_lwzsj2.png" 
            alt="National infrastructure background" 
            className="w-full h-full object-cover grayscale"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A] to-transparent"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="font-sans text-4xl sm:text-5xl font-bold text-white mb-6 tracking-tight">
            Ready to Build a Safer Nigeria?
          </h2>
          <p className="text-xl text-[#F8FAFC]/80 font-light mb-12">
            Government agencies, communities, partners and volunteers all have a role.
          </p>
          <a
            href="/partners"
            className="inline-block px-10 py-5 text-lg font-semibold text-white bg-[#16A34A] hover:bg-[#15803d] transition-colors duration-300"
          >
            Partner With Us
          </a>
        </div>
      </section>
    </div>
  );
}
